export enum QRCodeModel {
    Model1 = 'Model1',
    Model2 = 'Model2'
}